import dayjs from 'dayjs';
import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';
import ImageWithBasePath from '../../../../../core/common/imageWithBasePath';

const RecoJobInConstructionWithCheck = ({ printOutPdfDetails, printRef,onRenderReady }: any) => {
    const formatDate = (date: Date | string) => {
        return dayjs(date).format("MMM D, YYYY").toUpperCase();
    };
    const formattedDate = formatDate(new Date());
    useEffect(() => {
        if (printOutPdfDetails) {
            onRenderReady?.();
        }
    }, [printOutPdfDetails]);
    return (
        <div ref={printRef}>
            <div className='row' style={{ height: "270mm", backgroundColor: "#fff", padding: "2rem", overflow: "hidden",pageBreakAfter: "always" }}  >
                <div className='d-flex justify-content-center align-items-center'>
                    <ImageWithBasePath
                        src="assets/img/logo.svg"
                        className=""
                        alt="Logo"
                        width={300}
                        height={68}
                    />
                </div>
                <div className='text-end'>
                    {formattedDate}
                </div>
                <div>
                    <p className='mb-0'>
                        {printOutPdfDetails?.primaryContactFirstName} {printOutPdfDetails?.primaryContactLastName}
                    </p>
                    <p className='mb-0'>
                        {printOutPdfDetails?.secondaryContactFirstName} {printOutPdfDetails?.secondaryContactLastName}
                    </p>
                    <p className='mb-0'>
                        {printOutPdfDetails?.mailingAddressLine1}
                    </p>
                    <p className='mb-0'>
                        {printOutPdfDetails?.mailingAddressLine2}
                    </p>
                    <p className='mb-0'>
                        {printOutPdfDetails?.mailingCity} {" "} {printOutPdfDetails?.mailingState ? ',' : ''} {" "} {printOutPdfDetails?.mailingState} {" "}  {printOutPdfDetails?.mailingZipCode}
                    </p>
                </div>
                <div className='mt-3'>
                    Dear {printOutPdfDetails?.primaryContactFirstName} {printOutPdfDetails?.secondaryContactFirstName ? '&' : ''} {printOutPdfDetails?.secondaryContactFirstName} :

                </div>
                <p className='mt-2'>
                    Thank you for recently referring Airoom to {`<`}Referred Client's Name{`>`}.  We’ve received your recommendation form concerning this client and thanks to your kind words and generous referral, have already started construction on the {`<`}Referred Client's Name{`>`}’s project.  We appreciate that you thought of us and gave our name to someone you know.  We will initiate the necessary paperwork, as quickly as possible, to generate a referral check for you, in the amount of $750.00.
                </p>
                <p>
                    Thank you again for your kind words and helpful referral.  We look forward to seeing your name on several referral checks so please keep us in mind should anyone ask.
                </p>
                <p>In the meantime, I hope you are enjoying your project and if there is anything that we can do for you, please feel free to give me a call.</p>
                <p>
                    Sincerely,

                </p>
                <p className='mt-3 mb-0'>
                    Thomas D. Graham
                </p>
                <p>
                    Senior Vice President
                </p>
                <p>
                    TDG/lac
                </p>
                <div className='d-flex justify-content-center align-items-center mt-5' style={{ opacity: 0.1 }}>
                    <ImageWithBasePath
                        src="assets/img/logo-small.svg"
                        className=""
                        alt="Logo"
                        width={150}
                        height={68}

                    />
                </div>
                <div className='text-center mt-3'>
                    <p className='mb-0'>
                        <b>
                            CORPORATE OFFICES AND DESIGN CENTER {" "}
                        </b>
                        6825 N. Lincoln Ave., Lincolnwood, IL 60712 <b> BRANCH OFFICE</b> Hinsdale, IL
                    </p>
                    <p>
                        <b>AIROOM INC.</b> - 847.967.ROOM - 847.763.1101 (fax) - <Link to="https:/www.airoom.com" className='text-decoration-underline text-primary'>www.airoom.com</Link>
                    </p>
                </div>
            </div>

            <div className='row'  style={{ height: "270mm", backgroundColor: "#fff", padding: "2rem", overflow: "hidden",pageBreakAfter: "always" }}>
                <div className='d-flex justify-content-center align-items-center'>
                    <ImageWithBasePath
                        src="assets/img/logo.svg"
                        className=""
                        alt="Logo"
                        width={300}
                        height={68}

                    />
                </div>
                <div className='p-3 text-center  mt-3 border border-1 border-dark'>
                    <h2 className='text-dark'>CHECK REQUISITION</h2>
                </div>
                <>
                    <div className="container mt-4">
                        {/* Top Section */}
                        <div className="row border">
                            <div className="col-md-6 border-end p-2" style={{ flex: '0 0 50%', maxWidth: '50%' }}>
                                <strong>Payable To:</strong><br />
                                <div> {printOutPdfDetails?.primaryContactFirstName} {printOutPdfDetails?.primaryContactLastName} {printOutPdfDetails?.secondaryContactFirstName ? '/' : ''} {printOutPdfDetails?.secondaryContactFirstName}  {printOutPdfDetails?.secondaryContactLastName}</div>

                            </div>
                            <div className="col-md-6 p-2" style={{ flex: '0 0 50%', maxWidth: '50%' }}>
                                <div className="row">
                                    <div className="col-6 style={{ flex: '0 0 50%', maxWidth: '50%' }}"><strong>Date:</strong></div>
                                    <div className="col-6 style={{ flex: '0 0 50%', maxWidth: '50%' }}">{formattedDate}</div>
                                </div>
                            </div>

                            <div className="col-md-6 border-top border-end p-2" style={{ flex: '0 0 50%', maxWidth: '50%' }}>
                                <strong>Address</strong><br />
                                <p className='mb-0'>
                                    {printOutPdfDetails?.mailingAddressLine1}
                                </p>
                                <p className='mb-0'>
                                    {printOutPdfDetails?.mailingAddressLine2}
                                </p>
                            </div>
                            <div className="col-md-6 border-top p-2" style={{ flex: '0 0 50%', maxWidth: '50%' }}>
                                <div className="row">
                                    <div className="col-6" style={{ flex: '0 0 50%', maxWidth: '50%' }}><strong>Project Number:</strong></div>
                                    <div className="col-6" style={{ flex: '0 0 50%', maxWidth: '50%' }}>{printOutPdfDetails?.projectNumber}</div>
                                </div>
                            </div>

                            <div className="col-md-6 border-top border-end p-2" style={{ flex: '0 0 50%', maxWidth: '50%' }}>
                                <strong>City, State Zip</strong><br />
                                <p className='mb-0'>
                                    {printOutPdfDetails?.mailingCity} {" "} {printOutPdfDetails?.mailingState ? ',' : ''} {" "} {printOutPdfDetails?.mailingState} {" "}  {printOutPdfDetails?.mailingZipCode}
                                </p>
                            </div>
                            <div className="col-md-6 border-top p-2" style={{ flex: '0 0 50%', maxWidth: '50%' }}>
                                <strong>General Ledger Account</strong>
                            </div>
                        </div>

                        {/* Table Section */}
                        <div className='row'>
                            <table className="table table-template table-bordered mt-3" style={{ height: '400px' }} >
                                <thead>
                                    <tr>
                                        <th>Description</th>
                                        <th className="text-end">Amount</th>
                                    </tr>
                                </thead>
                                <tbody >
                                    <tr>
                                        <td>Referral of <strong>&lt;Referred Client's Name&gt;</strong></td>
                                        <td className="text-end">$750.00</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </>

                <div className='text-center mt-3'>
                    <p className='mb-0'>
                        <b>
                            CORPORATE OFFICES AND DESIGN CENTER {" "}
                        </b>
                        6825 N. Lincoln Ave., Lincolnwood, IL 60712 <b> BRANCH OFFICE</b> Hinsdale, IL
                    </p>
                    <p>
                        <b>AIROOM INC.</b> - 847.967.ROOM - 847.763.1101 (fax) - <Link to="https:/www.airoom.com" className='text-decoration-underline text-primary'>www.airoom.com</Link>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default RecoJobInConstructionWithCheck